import { Status, States } from '@sift/resift/models/Status';
import { RequestResolve } from '@sift/resift/redux/DataService';

export const initialState = {
  fetchGroupsResults: [],
  groupsStatus: new Status(),
};

// ------------------------------------
// Constants
// ------------------------------------
export const GROUPS_FETCH = 'GROUPS_FETCH';
export const GROUPS_FETCH_SUCCESS = 'GROUPS_FETCH_SUCCESS';
export const GROUPS_FETCH_ERROR = 'GROUPS_FETCH_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

export function fetchGroups(q, id) {
  return {
    type: GROUPS_FETCH,
    identifier: 'search/groups',
    payload: {
      query: {
        q,
      },
      id,
      requestResolve: RequestResolve.CANCEL,
    },
  };
}

// ------------------------------------
// Action Handlers
// -----------------------------------
const ACTION_HANDLERS = {
  [GROUPS_FETCH]: (state, action) => {
    return {
      ...state,
      groupsStatus: new Status(States.LOADING),
    };
  },
  [GROUPS_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      groupsStatus: new Status(States.NORMAL),
      fetchGroupsResults: action.payload.data.results,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function sourceReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
